module.exports = __webpack_public_path__ + "img/gitlab.b13af590.svg";